export const dropItemMap = {
  "label": "Trang Bị",
  "options": [
    {
      "value": 1,
      "label": "Thiết Kiếm",
      "type": 2
    },
    {
      "value": 2,
      "label": "Diệp Đao",
      "type": 2
    },
    {
      "value": 3,
      "label": "Bách Lý",
      "type": 2
    },
    {
      "value": 200,
      "label": "Bố Giáp",
      "type": 2
    },
    {
      "value": 201,
      "label": "Nộ Yến Khải",
      "type": 2
    },
    {
      "value": 202,
      "label": "Bát Nhã Khải",
      "type": 2
    },
    {
      "value": 400,
      "label": "Hoàng Phiêu",
      "type": 2
    },
    {
      "value": 401,
      "label": "Bão Nguyệt",
      "type": 2
    },
    {
      "value": 97,
      "label": "Thư Linh-Sơ",
      "type": 3
    },
    {
      "value": 98,
      "label": "Thư Linh-Trung",
      "type": 3
    },
    {
      "value": 99,
      "label": "Thư Linh-Cao",
      "type": 3
    },
    {
      "value": 402,
      "label": "Giác Kỳ Lân",
      "type": 2
    },
    {
      "value": 403,
      "label": "Hắc Long",
      "type": 2
    },
    {
      "value": 500,
      "label": "Choàng Gấm",
      "type": 2
    },
    {
      "value": 501,
      "label": "Kim Tước",
      "type": 2
    },
    {
      "value": 502,
      "label": "Võ Thánh",
      "type": 2
    },
    {
      "value": 503,
      "label": "Thiên Diểu",
      "type": 2
    },
    {
      "value": 300,
      "label": "Kinh Thi",
      "type": 2
    },
    {
      "value": 301,
      "label": "Tứ Dân Lệnh",
      "type": 2
    },
    {
      "value": 302,
      "label": "Độn Giáp Thư",
      "type": 2
    },
    {
      "value": 303,
      "label": "Binh Võ Kinh",
      "type": 2
    },
    {
      "value": 600,
      "label": "Mộc Thuẫn",
      "type": 2
    },
    {
      "value": 601,
      "label": "Thánh Thuẫn",
      "type": 2
    },
    {
      "value": 602,
      "label": "Long Thuẫn",
      "type": 2
    },
    {
      "value": 603,
      "label": "Thiên Thuẫn",
      "type": 2
    },
    {
      "value": 101,
      "label": "Hương Nang",
      "type": 2
    },
    {
      "value": 104,
      "label": "Bát Quái Kính",
      "type": 2
    },
    {
      "value": 103,
      "label": "Túy Thái Bình",
      "type": 2
    },
    {
      "value": 4,
      "label": "Chiến Đồ Đao",
      "type": 2
    },
    {
      "value": 203,
      "label": "Dương Khải",
      "type": 2
    },
    {
      "value": 7,
      "label": "Phong Đô Kiếm",
      "type": 2
    },
    {
      "value": 8,
      "label": "Lục Thương",
      "type": 2
    },
    {
      "value": 9,
      "label": "Phong Tà Kiếm",
      "type": 2
    },
    {
      "value": 206,
      "label": "Hoàng Giáp",
      "type": 2
    },
    {
      "value": 207,
      "label": "Bế Phương Y",
      "type": 2
    },
    {
      "value": 208,
      "label": "Vạn Kiếp Khải",
      "type": 2
    },
    {
      "value": 406,
      "label": "Ảnh Tầm Câu",
      "type": 2
    },
    {
      "value": 407,
      "label": "Phần Hổ",
      "type": 2
    },
    {
      "value": 408,
      "label": "Tử Kỳ Lân",
      "type": 2
    },
    {
      "value": 506,
      "label": "Bách Thế Sa",
      "type": 2
    },
    {
      "value": 507,
      "label": "Đế Phần Văn",
      "type": 2
    },
    {
      "value": 508,
      "label": "Mũ Đại Vũ",
      "type": 2
    },
    {
      "value": 306,
      "label": "Ngự Binh Nghệ",
      "type": 2
    },
    {
      "value": 307,
      "label": "Long Điển",
      "type": 2
    },
    {
      "value": 308,
      "label": "Lục Đạo Quyết",
      "type": 2
    },
    {
      "value": 606,
      "label": "Tử Hiên Thuẫn",
      "type": 2
    },
    {
      "value": 607,
      "label": "Cứu Viêm Kính",
      "type": 2
    },
    {
      "value": 608,
      "label": "Độ Luân Thuẫn",
      "type": 2
    },
    {
      "value": 106,
      "label": "Xích Nhãn",
      "type": 2
    },
    {
      "value": 107,
      "label": "Tài Quyết Ấn",
      "type": 2
    },
    {
      "value": 100,
      "label": "Long Lệnh",
      "type": 2
    },
    {
      "value": 1000,
      "label": "Ứng Long Châu",
      "type": 1
    },
    {
      "value": 1001,
      "label": "Chúc Âm Châu",
      "type": 1
    },
    {
      "value": 10,
      "label": "Chúc Âm Thương",
      "type": 2
    },
    {
      "value": 209,
      "label": "Chúc Âm Chiến y",
      "type": 2
    },
    {
      "value": 1002,
      "label": "Thiên Xu Thạch",
      "type": 1
    },
    {
      "value": 1005,
      "label": "Thiên Toàn Thạch",
      "type": 1
    },
    {
      "value": 1004,
      "label": "Thiên Cơ Thạch",
      "type": 1
    },
    {
      "value": 1003,
      "label": "Thiên Quyền Thạch",
      "type": 1
    },
    {
      "value": 1006,
      "label": "Ngọc Hành Thạch",
      "type": 1
    },
    {
      "value": 1007,
      "label": "Khai Dương Thạch",
      "type": 1
    },
    {
      "value": 1008,
      "label": "Diêu Quang Thạch",
      "type": 1
    },
    {
      "value": 1009,
      "label": "Hoàng Châu",
      "type": 1
    },
    {
      "value": 1010,
      "label": "Thần Thạch",
      "type": 1
    },
    {
      "value": 11,
      "label": "Thần Nguyệt Cung",
      "type": 2
    },
    {
      "value": 210,
      "label": "Thất Hải Giáp",
      "type": 2
    },
    {
      "value": 109,
      "label": "Thần Đỉnh",
      "type": 2
    },
    {
      "value": 1011,
      "label": "Vũ Thạch",
      "type": 1
    },
    {
      "value": 1012,
      "label": "Nguyệt Thạch",
      "type": 1
    },
    {
      "value": 1013,
      "label": "Di Thạch",
      "type": 1
    },
    {
      "value": 12,
      "label": "Diệt Thế Kiếm",
      "type": 2
    },
    {
      "value": 211,
      "label": "Diệt Thế Giáp",
      "type": 2
    },
    {
      "value": 110,
      "label": "Diệt Thế Khí",
      "type": 2
    },
    {
      "value": 1014,
      "label": "Tụ Thạch",
      "type": 1
    },
    {
      "value": 1015,
      "label": "Lê Thạch",
      "type": 1
    },
    {
      "value": 1016,
      "label": "Trần Thạch",
      "type": 1
    },
    {
      "value": 1017,
      "label": "Tiểu Thạch",
      "type": 1
    },
    {
      "value": 1018,
      "label": "Ẩn Long Thạch",
      "type": 1
    },
    {
      "value": 13,
      "label": "Liệt Thiên Phủ",
      "type": 2
    },
    {
      "value": 212,
      "label": "Đại Địa Giáp",
      "type": 2
    },
    {
      "value": 412,
      "label": "Hỗn Độn Thú",
      "type": 2
    },
    {
      "value": 512,
      "label": "Phi Tinh Văn",
      "type": 2
    },
    {
      "value": 312,
      "label": "Niết Bàn Điển",
      "type": 2
    },
    {
      "value": 612,
      "label": "Nguyên Thuẫn",
      "type": 2
    },
    {
      "value": 111,
      "label": "Âm Dương Phù",
      "type": 2
    },
    {
      "value": 1020,
      "label": "Không Linh Thạch",
      "type": 1
    },
    {
      "value": 1019,
      "label": "Đoạn Nhạc Thạch",
      "type": 1
    },
    {
      "value": 1021,
      "label": "Chân Võ Thạch",
      "type": 1
    },
    {
      "value": 1022,
      "label": "Vân Thạch",
      "type": 1
    },
    {
      "value": 1023,
      "label": "Thiên Khôi Thạch",
      "type": 1
    },
    {
      "value": 14,
      "label": "Hỗn Độn-Bàn Long Kiếm",
      "type": 1
    },
    {
      "value": 213,
      "label": "Hỗn Độn-Phẫn Ảnh Y",
      "type": 1
    },
    {
      "value": 413,
      "label": "Hỗn Độn-Tinh Viên Thú",
      "type": 1
    },
    {
      "value": 513,
      "label": "Hỗn Độn-Thông Thiên Lạp",
      "type": 1
    },
    {
      "value": 313,
      "label": "Hỗn Độn-Thiên Khởi Lục",
      "type": 1
    },
    {
      "value": 613,
      "label": "Hỗn Độn-Tu Di Thuẫn",
      "type": 1
    },
    {
      "value": 112,
      "label": "Hỗn Độn-Phạm Âm Chung",
      "type": 1
    },
    {
      "value": 1025,
      "label": "Diệt Độ Thạch",
      "type": 1
    },
    {
      "value": 1026,
      "label": "Tịch Diệt Thạch",
      "type": 1
    },
    {
      "value": 1027,
      "label": "Luân Hồi Thạch",
      "type": 1
    },
    {
      "value": 1028,
      "label": "Vô Tướng Thạch",
      "type": 1
    },
    {
      "value": 1029,
      "label": "Khai Thạch",
      "type": 1
    },
    {
      "value": 1030,
      "label": "Huyền Thạch",
      "type": 1
    },
    {
      "value": 1032,
      "label": "Hỗn Thạch",
      "type": 1
    },
    {
      "value": 1031,
      "label": "Thiên Thạch",
      "type": 1
    },
    {
      "value": 1033,
      "label": "Lưu Thạch",
      "type": 1
    },
    {
      "value": 1034,
      "label": "Kim Minh Thạch",
      "type": 1
    },
    {
      "value": 1035,
      "label": "Xích Luyện Thạch",
      "type": 1
    },
    {
      "value": 1036,
      "label": "Mộc Dương Thạch",
      "type": 1
    },
    {
      "value": 1037,
      "label": "Li Hỏa Thạch",
      "type": 1
    },
    {
      "value": 1038,
      "label": "Thái Ất Thạch",
      "type": 1
    },
    {
      "value": 3000,
      "label": "Đá Tinh Luyện-Sơ",
      "type": 1
    },
    {
      "value": 3001,
      "label": "Đá Tinh Luyện-Cao",
      "type": 1
    },
    {
      "value": 4001,
      "label": "Mảnh Binh Thư Vạn Năng",
      "type": 1
    },
    {
      "value": 4003,
      "label": "Mảnh Binh Thư Vạn Năng 2",
      "type": 1
    },
    {
      "value": 4004,
      "label": "Mảnh Binh Thư Vạn Năng 3",
      "type": 1
    }
  ]
}